export default {"src":"/_next/static/media/0x0d8775f648430679a709e98d2b0cb6250d2887ef.bced648f.svg","height":2000,"width":2000,"blurWidth":0,"blurHeight":0};